import { useEffect, useState } from 'react'

export function useIntervalUpdate(durationInMs: number = 1000) {
  const [updatesCount, setUpdatesCount] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setUpdatesCount(prevCounter => prevCounter + 1)
    }, durationInMs)

    return function cleanup() {
      clearInterval(interval)
    }
  }, [durationInMs])

  return { updatesCount }
}
